import Vue from 'vue'
import Router from 'vue-router'
import appConfig from '@/config/index'
import { getToken } from '@/util/token'

Vue.use(Router)

// 判断是否需要登录访问, 配置位于 config 文件夹
let isLoginRequired = routeName => {
  // 首次执行时缓存配置
  let { notLoginRoute } = appConfig
  const notLoginMark = {}

  // 构建标记对象
  if (Array.isArray(notLoginRoute)) {
    for (let i = 0; i < notLoginRoute.length; i += 1) {
      notLoginMark[notLoginRoute[i].toString()] = true
    }
  }

  notLoginRoute = null // 释放内存

  // 重写初始化函数
  isLoginRequired = name => {
    if (!name) {
      return true
    }
    // 处理 Symbol 类型
    const target = typeof name === 'symbol' ? name.description : name
    return !notLoginMark[target]
  }

  return isLoginRequired(routeName)
}

const router = new Router({
  // mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import('@/components/layout/main')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login/login')
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 登录验证
  console.log('路由地址: ', to.name)
  const token = getToken()
  // 登录验证
  if (isLoginRequired(to.name) && !token) {
    console.log('没有登录，需要先登录  ', token)
    next({ path: '/login' })
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js